import i18n from '@assets/i18n/index';
import type { Experience } from '@models/experience/experience';
import type { TypeItem } from '@experience/static/config/experience.type';

export const REDIRECT_PAGE_CONDITION_KEY = 'REDIRECT_ORIGINAL_PAGE';

export const experienceTypeList: TypeItem[] = [
    {
        key: 'POPUP',
        name: 'experience.common.popup',
        desc: 'experience.common.popup_desc',
        icon: 'pt-pic-popup',
        buttonText: 'experience.setting.add_popup',
        abname: 'experience.common.ab_popup',
        abButtonText: 'experience.common.ab_test_button',
        templateTitle: 'experience.common.popup_template_title',
        blankText: 'experience.common.popup_blank_text',
        abdesc: 'experience.common.ab_popup_desc',
        trackKey: 'popup',
        tagTypes: ['POPUP', 'STICKY_BAR'],
        introList: [
            'experience.onboarding.engagement_example1',
            'experience.onboarding.engagement_example2',
            'experience.onboarding.engagement_example3'
        ]
    },
    {
        key: 'INLINE',
        name: 'experience.common.inline',
        desc: 'experience.common.inline_desc',
        icon: 'pt-pic-inline',
        buttonText: 'experience.setting.add_inline',
        abname: 'experience.common.ab_inline',
        abButtonText: 'experience.common.ab_test_button',
        templateTitle: 'experience.common.inline_template_title',
        blankText: 'experience.common.inline_blank_text',
        abdesc: 'experience.common.ab_inline_desc',
        trackKey: 'inline',
        tagTypes: ['INLINE'],
        introList: [
            'experience.onboarding.inline_example1',
            'experience.onboarding.inline_example2',
            'experience.onboarding.inline_example3'
        ]
    },
    {
        key: 'ADVANCED',
        name: 'experience.common.advance',
        desc: 'experience.common.advance_desc',
        icon: 'pt-pic-advanced1',
        buttonText: 'experience.setting.add_advanced',
        abname: 'experience.common.ab_advance',
        abButtonText: 'experience.common.ab_test_button',
        templateTitle: '',
        blankText: '',
        abdesc: 'experience.common.ab_advance_desc',
        trackKey: 'advance',
        tagTypes: ['ADVANCED'],
        introList: ['experience.onboarding.advance_example1']
    },
    {
        key: 'ABTEST',
        name: 'experience.common.abtest',
        desc: 'experience.common.abtest_desc',
        icon: 'pt-pic-ABtest',
        buttonText: 'experience.setting.add_abtest',
        abname: '',
        templateTitle: 'experience.common.ab_template_title',
        blankText: 'Edit page from your own idea',
        abdesc: '',
        trackKey: 'a/b_test',
        tagTypes: ['ABTEST']
    },
    {
        key: 'REDIRECT',
        name: 'experience.common.redirect',
        desc: 'experience.common.redirect_desc',
        icon: 'pt-pic-redirect-testing',
        buttonText: 'experience.setting.add_redirect',
        abname: '',
        templateTitle: 'ABTesting Template',
        blankText: '',
        abdesc: '',
        trackKey: 'redirect',
        tagTypes: ['REDIRECT']
    }
];

export const abtestTypeList = [
    {
        key: 'new',
        name: 'experience.common.new_abtest_title',
        desc: 'experience.common.new_abtest_desc'
    },
    {
        key: 'exist',
        name: 'experience.common.exist_abtest_title',
        desc: 'experience.common.exist_abtest_desc'
    }
];

export const experienceStatusList = [
    {
        key: 'running',
        name: 'experience.common.state_running'
    },
    {
        key: 'pause',
        name: 'experience.common.state_off'
    },
    {
        key: 'scheduled',
        name: 'experience.common.state_scheduled'
    },
    {
        key: 'draft',
        name: 'experience.common.state_draft'
    }
];

export const statusMapObj = {
    0: 'DRAFT',
    1: 'RUNNING',
    2: 'PAUSE',
    3: 'SCHEDULED'
};

export const colorMap: any = {
    c1: '#58C70F',
    c2: '#BF826E',
    c3: '#7FE7D6',
    c4: '#FF7558',
    c5: '#6D7A04',
    c6: '#E2B47C',
    c7: '#804774',
    c8: '#F2CA52',
    c9: '#775F47',
    c10: '#E95D79'
};

export const deviceOptions = [
    {
        key: 'PC',
        name: 'landing_page_common.device_pc',
        default: true
    },
    {
        key: 'MOBILE',
        name: 'landing_page_common.device_sp'
    }
];

export const templateTabList = [
    {
        key: 'COMMON',
        name: 'experience.setting.templates'
    },
    {
        key: 'OWN',
        name: 'experience.setting.my_templates'
    }
];

export const templateTypeCategoryList = [
    {
        key: 'popup',
        name: 'experience.setting.popup',
        isChecked: false
    },
    {
        key: 'sticky_bar',
        name: 'experience.setting.stickybar',
        isChecked: false
    }
];

export const operateList = [
    // {
    //     command: 'Add',
    //     name: 'experience.setting.template_add'
    // },
    {
        command: 'Edit',
        name: 'experience.setting.template_edit'
    },
    {
        command: 'Delete',
        name: 'experience.setting.template_delete'
    }
];

export const settingItemList = [
    {
        key: 'creative',
        name: 'experience.setting.creative_title',
        containerClass: '.NAV_CREATIVE',
        module: 'CREATIVE',
        default: true
    },
    {
        key: 'trigger',
        name: 'experience.setting.trigger_title',
        containerClass: '.NAV_TRIGGER',
        module: 'TRIGGER'
    },
    {
        key: 'shown',
        name: 'experience.setting.page_condition_title',
        containerClass: '.NAV_CONDITION',
        module: 'CONDITION'
    },
    {
        key: 'usergroup',
        name: 'experience.setting.user_group_title',
        containerClass: '.NAV_USER_GROUP',
        module: 'USER_GROUP'
    },
    {
        key: 'goal',
        name: 'experience.setting.goal_title',
        containerClass: '.NAV_GOAL',
        module: 'GOAL'
    },
    {
        key: 'schedule',
        name: 'experience.setting.schedule_title',
        containerClass: '.NAV_SCHEDULE',
        module: 'SCHEDULE'
    },
    {
        key: 'review',
        name: 'experience.setting.review_title',
        containerClass: '.NAV_REVIEW',
        module: 'REVIEW'
    }
];

export const templateTypeFilterList = [
    {
        key: 'Web Editing',
        name: 'experience.onboarding.tags.Web Editing',
        isChecked: false
    },
    {
        key: 'Engagement',
        name: 'experience.onboarding.tags.Engagement',
        isChecked: false
    },
    {
        key: 'ABtesting',
        name: 'experience.onboarding.tags.ABtesting',
        isChecked: false
    }
];
export const popupTypeFilterList = [
    {
        key: 'popup',
        name: 'experience.setting.popup',
        isChecked: false
    },
    {
        key: 'sticky_bar',
        name: 'experience.setting.stickybar',
        isChecked: false
    }
];

export const templatePurposeFilterList = [
    {
        key: 'Generate leads',
        name: 'experience.onboarding.tags.Generate leads',
        isChecked: false
    },
    {
        key: 'Prevent abandonment',
        name: 'experience.onboarding.tags.Prevent abandonment',
        isChecked: false
    },
    {
        key: 'Promotion',
        name: 'experience.onboarding.tags.Promotion',
        isChecked: false
    },
    {
        key: 'Recommendation',
        name: 'experience.onboarding.tags.Recommendation',
        isChecked: false
    },
    {
        key: 'Collect user info',
        name: 'experience.onboarding.tags.Collect user info',
        isChecked: false
    },
    {
        key: 'Guide & notify visitors',
        name: 'experience.onboarding.tags.Guide & notify visitors',
        isChecked: false
    },
    {
        key: 'Improve engagement',
        name: 'experience.onboarding.tags.Improve engagement',
        isChecked: false
    }
];

export const templateIndustryFilterList = [
    {
        key: 'E-commerce',
        name: 'experience.onboarding.tags.E-commerce',
        isChecked: false
    },
    {
        key: 'B2B service',
        name: 'experience.onboarding.tags.B2B service',
        isChecked: false
    },
    {
        key: 'Offline store', //Offline store
        name: 'experience.onboarding.tags.Offline store',
        isChecked: false
    },
    {
        key: 'Others',
        name: 'experience.onboarding.tags.Others',
        isChecked: false
    }
];

export const engageTypeMap = {
    POPUP: 'popup &Sticky bar',
    STICKY_BAR: 'Popup &Sticky bar',
    INLINE: 'Inline',
    ADVANCED: 'Advanced'
};

export const langMap: {
    [key: string]: string;
} = {
    jp: 'Japanese',
    en: 'English',
    zh: 'Chinese'
};

export const pteInstallCode = `<!-- Ptengine Tag -->
<script src="https://js.ptengine.jp/{sid}.js"></script>
<!-- End Ptengine Tag -->`;

export const pteInstallCodeHTML = `<!-- Ptengine Tag -->
<script src="https://js.ptengine.jp/{sid}.js">
</script>
<!-- End Ptengine Tag -->`;

/**
 * @TODO 此方法有三处声明 需要统一一下。
 * 检测未完成项
 */
export function checkFinishStatus(experienceInfo: Experience) {
    let items = [];
    const { versions, enableABTest, goals, engageType } = experienceInfo;
    if (!versions || versions?.length <= 0) {
        items.push({
            errorType: 'CreativeUndo',
            errorMsg: i18n.global.t(
                `experience.setting.${
                    engageType === 'REDIRECT' ? 'redirect_creative_undo' : 'creative_undo'
                }`
            )
        });
    } else {
        const errorVersion = (versions || []).find(version => {
            return version.terminals?.some(t => {
                const { popup, stickybar } = t || {};
                return (
                    (popup || []).some((p: any) => p.popupHasError) ||
                    (stickybar || []).some((p: any) => p.popupHasError)
                );
            });
        });
        if (errorVersion) {
            items.push({
                errorType: 'CreativeUnFinished',
                errorMsg: i18n.global.t('experience.setting.creative_unfinshed'),
                errorVersion
            });
        }
    }

    if (enableABTest && versions.length === 1) {
        items.push({
            errorType: 'ABTestUndo',
            errorMsg: i18n.global.t('experience.setting.abtest_undo')
        });
    }
    if (enableABTest && !goals?.length) {
        items.push({
            errorType: 'ABTestNoGoal',
            errorMsg: i18n.global.t('experience.setting.abtest_no_goal')
        });
    }
    return items;
}
